import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Page404Component } from './shared/page404/page404.component';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'sistema', pathMatch: "full" },
  {
    path: 'sistema', loadChildren: () => import('./platform/platform.module').then(m => m.PlatformModule),
 },
  { path: 'website', loadChildren: () => import('./website/website.module').then(m => m.WebsiteModule) },
  { path: 'page404', component: Page404Component },
  { path: "**", redirectTo: "page404", pathMatch: "full" }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
